import { render, staticRenderFns } from "./SecurityComponent.vue?vue&type=template&id=6e92bd16&lang=html&"
import script from "./SecurityComponent.vue?vue&type=script&lang=js&"
export * from "./SecurityComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports